import Dropdown from "react-dropdown";
import React, {useContext, useEffect, useState} from "react";
import OutsideClickHandler from "react-outside-click-handler/esm/OutsideClickHandler";
import {store} from '../../Store/store';


export default function AssigneeDropdownEditor({row,options,value,toggleCommCheckBox,handleOnEdit,onUpdate}) {
    const [isEditing, setIsEditing] = useState(true);
    const stateObj = useContext(store);
    const isRequestInProgress = stateObj.state.isRequestInProgress;
    const dropDownDisabled = isRequestInProgress.state && isRequestInProgress.rowId === row.id;

    const getAssigneeValue = () => {
        const result = options.filter(option => {
            let one = option.value.toString();
            let two = value.toString();
            return one === two;
        })
        return result;
    }

    const currentAssignee = getAssigneeValue()

    const finalizeEditing = () => {
        toggleCommCheckBox(false, row.id);
        setIsEditing(false);
        handleOnEdit(false);
    }

    useEffect(() => {
        if (isEditing) {
            toggleCommCheckBox(true, row.id);
            handleOnEdit(true);
        }
    }, [isEditing])

    const handleChange = (e) => {
        finalizeEditing();
        onUpdate(e.value);
    };

    return (<OutsideClickHandler
        onOutsideClick={() => {
            finalizeEditing();
            onUpdate(currentAssignee[0].value);
        }}
    >
        <Dropdown controlClassName='dropDownControl' menuClassName='menuAssigneeControl' value={currentAssignee[0].label}
                  options={options}
                  onChange={handleChange}
                  disabled={dropDownDisabled}
        />
    </OutsideClickHandler>)
}

